(function () {
  var module3Timeline = null;
  var rebuildTimer = null;
  var isInitialized = false;
  var STABLE_CHECK_MAX_RETRIES = 30;

  function getModule3Image(imagePc, imageH5) {
    if (imagePc && window.getComputedStyle(imagePc).display !== "none") {
      return imagePc;
    }
    if (imageH5 && window.getComputedStyle(imageH5).display !== "none") {
      return imageH5;
    }
    return imagePc || imageH5;
  }

  function clearModule3InlineStyles(imagePc, imageH5, imageBox, heading, paragraph) {
    var resetTargets = [imagePc, imageH5, imageBox, heading, paragraph].filter(Boolean);
    if (!resetTargets.length || !window.gsap) {
      return;
    }

    gsap.set(resetTargets, {
      clearProps: "height,overflow,display,justifyContent,alignItems,marginTop,willChange,width,scale,transformOrigin,force3D,y,opacity,transform",
    });
  }

  function killModule3Animation() {
    if (!module3Timeline) {
      return;
    }

    if (module3Timeline.scrollTrigger) {
      module3Timeline.scrollTrigger.kill();
    }
    module3Timeline.kill();
    module3Timeline = null;
  }

  function buildModule3Animation() {
    var module3ImagePc = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img .img_pc");
    var module3ImageH5 = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img .img_h5");
    var module3ImageBox = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img");
    var module3Heading = document.querySelector("#UT2_2026 .ut2_module3 h4");
    var module3Paragraph = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module_p");

    if (!module3ImagePc && !module3ImageH5) {
      return;
    }

    killModule3Animation();
    clearModule3InlineStyles(module3ImagePc, module3ImageH5, module3ImageBox, module3Heading, module3Paragraph);

    // 强制浏览器完成布局计算
    if (module3ImageBox) void module3ImageBox.offsetHeight;
    if (module3ImagePc) void module3ImagePc.offsetHeight;
    if (module3ImageH5) void module3ImageH5.offsetHeight;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var isMobile = viewportWidth <= 768;
    var isDesktop = viewportWidth > 1080;
    var module3Image = getModule3Image(module3ImagePc, module3ImageH5);

    if (isMobile || !module3Image || !module3ImageBox) {
      return;
    }

    var imageFinalWidth = isDesktop ? viewportWidth * 0.6640625 : viewportWidth * 0.86388889;
    var imageStartScale = isDesktop ? 1.96 : 1.35;
    var imageBoxMarginTop = isDesktop ? viewportWidth * 0.02 : viewportWidth * 0.03;
    var imageBoxEndHeight = isDesktop ? viewportWidth * 0.4 : viewportWidth * 0.52;
    var animationDistance = isDesktop ? "+=65%" : "+=55%";

    gsap.set(module3ImageBox, {
      height: imageBoxEndHeight,
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      marginTop: imageBoxMarginTop,
      willChange: "transform",
      force3D: true,
    });

    gsap.set(module3Image, {
      width: imageFinalWidth,
      scale: imageStartScale,
      transformOrigin: "50% 0%",
      force3D: true,
      willChange: "transform",
    });

    if (module3Heading) {
      gsap.set(module3Heading, { y: 140, opacity: 0 });
    }

    if (module3Paragraph) {
      gsap.set(module3Paragraph, { y: 140, opacity: 0 });
    }

    module3Timeline = gsap.timeline({
      scrollTrigger: {
        trigger: "#UT2_2026 .ut2_module3",
        start: "top 85%",
        end: animationDistance,
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    module3Timeline.to(module3Image, { scale: 1, ease: "none" }, 0);

    if (module3Heading) {
      module3Timeline.to(module3Heading, { y: 0, opacity: 1, ease: "none" }, 0);
    }

    if (module3Paragraph) {
      module3Timeline.to(module3Paragraph, { y: 0, opacity: 1, ease: "none" }, 0);
    }
  }

  function isModule3LayoutStable() {
    var module3ImagePc = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img .img_pc");
    var module3ImageH5 = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img .img_h5");
    var module3ImageBox = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img");
    var module3Image = getModule3Image(module3ImagePc, module3ImageH5);

    if (!module3ImageBox || !module3Image) {
      return false;
    }

    var boxRect = module3ImageBox.getBoundingClientRect();
    var imageRect = module3Image.getBoundingClientRect();
    var hasBoxSize = boxRect.width > 0 && boxRect.height > 0;
    var hasImageSize = imageRect.width > 0 && imageRect.height > 0;
    var imageReady = module3Image.getAttribute("src") && module3Image.complete && module3Image.naturalHeight !== 0;

    return hasBoxSize && hasImageSize && imageReady;
  }

  function buildModule3AnimationWhenStable(retry) {
    var nextRetry = retry || 0;

    if (!isModule3LayoutStable() && nextRetry < STABLE_CHECK_MAX_RETRIES) {
      setTimeout(function() {
        buildModule3AnimationWhenStable(nextRetry + 1);
      }, 100);
      return;
    }

    buildModule3Animation();
    if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }

  function scheduleRebuild() {
    if (rebuildTimer) {
      clearTimeout(rebuildTimer);
    }
    rebuildTimer = setTimeout(function() {
      buildModule3AnimationWhenStable(0);
    }, 150);
  }

  function ensureImageSource(imageEl) {
    if (!imageEl || imageEl.getAttribute("src")) {
      return;
    }

    var lazySrc = imageEl.getAttribute("data-lazysrc");
    if (lazySrc) {
      imageEl.setAttribute("src", lazySrc);
    }
  }

  function waitForImagesLoaded(callback) {
    var module3ImagePc = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img .img_pc");
    var module3ImageH5 = document.querySelector("#UT2_2026 .ut2_module3 .ut2_module3_img .img_h5");

    ensureImageSource(module3ImagePc);
    ensureImageSource(module3ImageH5);

    var module3Image = getModule3Image(module3ImagePc, module3ImageH5);

    if (!module3Image) {
      setTimeout(function() {
        waitForImagesLoaded(callback);
      }, 100);
      return;
    }

    // 检查图片是否已加载（缓存或已加载）
    if (module3Image.getAttribute("src") && module3Image.complete && module3Image.naturalHeight !== 0) {
      callback();
      return;
    }

    var loaded = false;
    var onLoad = function() {
      if (!loaded) {
        loaded = true;
        callback();
      }
    };

    module3Image.addEventListener("load", onLoad, { once: true });
    module3Image.addEventListener("error", onLoad, { once: true });

    // 降级方案：5秒后强制初始化
    setTimeout(function() {
      if (!loaded) {
        loaded = true;
        callback();
      }
    }, 8000);
  }

  function initAnimation() {
    if (!window.gsap || !window.ScrollTrigger || isInitialized) {
      return;
    }

    isInitialized = true;
    gsap.registerPlugin(ScrollTrigger);

    // 增加延迟确保所有布局计算完成
    setTimeout(function() {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          buildModule3AnimationWhenStable(0);
        });
      });
    }, 300);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleRebuild);
    }

    window.addEventListener("resize", scheduleRebuild);
    window.addEventListener("orientationchange", scheduleRebuild);
    window.addEventListener("pageshow", scheduleRebuild);
    window.addEventListener("load", scheduleRebuild);
  }

  // 等待页面完全加载后再初始化
  if (document.readyState === "complete") {
    waitForImagesLoaded(initAnimation);
  } else {
    window.addEventListener("load", function() {
      waitForImagesLoaded(initAnimation);
    });
  }

  var mySwiper = new Swiper('.swiper_ut2', {
      // 核心配置：实现一屏3个+中间固定
      slidesPerView: 1.5,        // 一屏显示3个slide
      centeredSlides: true,    // 中间的slide居中显示（核心）
      spaceBetween: 50,        // 每个slide之间的间距（可根据需求调整）

      // 保留你原有的配置
      navigation: {
        nextEl: '.swiper-button-next.swiper-button1',
        prevEl: '.swiper-button-prev.swiper-button1',
      },
      loop: false,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },

    
    });
})();
